export default "__VITE_ASSET__899aed4d__"